export const compareByAlpha = (a, b) => {
    if (a == null && b != null) return -1;
    else if (a != null && b == null) return 1;
    else if (a > b) return -1;
    else if (a < b) return 1;
    else return 0;
};